<template>
  <div class="page page__list">
    <search-bar
      @search="onSearch"
      name="ms_emname,ms_department"
      placeholder="输入补卡人、部门进行查找"
      ref="searchBar"
    />
    <filter-bar @change="onSearch" :filters="filters" ref="filterBar" />
    <scroll-list @refresh="onSearch" @loadpage="onSearchNext">
      <router-link
        class="weui-cell weui-cell_access"
        v-for="item in items"
        :key="item.id"
        :to="'/oa/signcard/'+item.id"
      >
        <div class="weui-cell__bd">
          <p>{{item.ms_emname}}</p>
          <p class="list-item-muted">{{item.ms_signtime}}</p>
        </div>
        <div class="weui-cell__ft">
          <p>{{item.ms_code}}</p>
          <span
            class="list-item-status"
            :class="{'warning':item.ms_status!='已审核'}"
          >{{item.ms_status}}</span>
        </div>
      </router-link>
    </scroll-list>
    <div class="list-footer">
      <label class="list-footer__label">合计：{{items.length}}次</label>
    </div>
    <add-button to="/oa/signcard_edit" />
  </div>
</template>

<script>
import SearchBar from "@/components/SearchBar.vue";
import FilterBar from "@/components/FilterBar.vue";
import ScrollList from "@/components/ScrollList.vue";
import AddButton from "@/components/button/Add.vue";
import list from "@/mixins/list.js";

export default {
  components: {
    SearchBar,
    FilterBar,
    ScrollList,
    AddButton
  },
  mixins: [list],
  data() {
    return {
      listUrl: "/api/oa/mobilesigncard/list",
      filters: [
        {
          type: "date",
          name: "ms_date"
        },
        {
          type: "condition",
          label: "状态",
          value: -1,
          options: [
            {
              value: -1,
              label: "全部"
            },
            {
              value: 1,
              label: "待审核",
              condition: "ms_statuscode='UNAUDITED'"
            },
            {
              value: 2,
              label: "已审核",
              condition: "ms_statuscode='AUDITED'"
            }
          ]
        }
      ]
    };
  }
};
</script>